import {
  useAvailableDates,
  useAvailableDatesForRescheduleTask,
} from '@app/api';

export interface PaginatedAvailableDates {
  availableDates?: Date[];
  fetchNextPage: () => any;
  hasNextPage: boolean;
  isLoading?: boolean;
}

export const usePaginatedAvailableDates = (
  taskSettingId?: string,
): PaginatedAvailableDates => {
  const paginatedDates = useAvailableDates(taskSettingId);
  const availableDates = paginatedDates?.data?.pages.reduce(
    (acc, page) => acc.concat(page.dates),
    [] as Date[],
  );
  return {
    availableDates,
    fetchNextPage: paginatedDates.fetchNextPage,
    hasNextPage: !!paginatedDates.hasNextPage,
    isLoading: paginatedDates.isLoading,
  };
};

export const usePaginatedAvailableDatesForReschedule = (
  taskId?: string,
): PaginatedAvailableDates => {
  const paginatedDates = useAvailableDatesForRescheduleTask(taskId);
  const availableDates = paginatedDates?.data?.pages.reduce(
    (acc, page) => acc.concat(page.dates),
    [] as Date[],
  );
  return {
    availableDates,
    fetchNextPage: paginatedDates.fetchNextPage,
    hasNextPage: !!paginatedDates.hasNextPage,
  };
};
